// src/pages/admin/MasterData.jsx

import React from 'react';

const MasterData = () => {
  return (
    <div className="p-4">
      <h1>Master Data</h1>
      <p>Halaman ini menampilkan antarmuka manajemen data referensi, termasuk pengelolaan data Provinsi, Kabupaten/Kota, dan Jenis Usaha.</p>
    </div>
  );
};

export default MasterData;
